import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight"];
import { Media } from '../Media';
import { MediaBody } from '../MediaBody';
import { MediaLeft } from '../MediaLeft';
import { MediaRight } from '../MediaRight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MediaObject = _ref => {
  let {
      children,
      itemLeft,
      itemRight,
      MediaBody: _MediaBody = MediaBody,
      MediaLeft: _MediaLeft = MediaLeft,
      MediaRight: _MediaRight = MediaRight
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Media, Object.assign({}, rest, {
    children: [itemLeft ? /*#__PURE__*/_jsx(_MediaLeft, {
      children: itemLeft
    }) : null, /*#__PURE__*/_jsx(_MediaBody, {
      children: children
    }), itemRight ? /*#__PURE__*/_jsx(_MediaRight, {
      children: itemRight
    }) : null]
  }));
};
MediaObject.displayName = 'MediaObject';